module.exports = __webpack_public_path__ + "static/img/medal1.158a93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/medal1.png
// module id = ICuM
// module chunks = 1